
import { OrderProduct } from '../../../types/orderTypes';

/**
 * Calculate the total price for a product based on quantity and price
 */
export const calculateProductTotal = (price: number, quantity: number): number => {
  return price * quantity;
};

/**
 * Recalculate the total amount for all products in an order
 */
export const calculateOrderTotal = (products: OrderProduct[]): number => {
  return products.reduce((sum, product) => {
    return sum + (product.total || calculateProductTotal(product.price, product.quantity));
  }, 0);
};
